import { FC, RefObject } from 'react';
import styled from 'styled-components';
import { Button, Popover, Stack, Typography } from '@mui/material';

const StyledPopover = styled(Popover)`
  .MuiPaper-root {
    display: flex;
    flex-direction: column;
    width: 320px;
  }
`;

const Body = styled(Stack)`
  padding: ${({ theme }) => theme.spacing(3)};
  gap: ${({ theme }) => theme.spacing(1)};
`;

type Props = {
  isOpen: boolean;
  onClose: () => void;
  anchorRef: RefObject<HTMLButtonElement>;
};

const ProductCatalogModal: FC<Props> = ({ anchorRef, isOpen, onClose }) => (
  <StyledPopover
    anchorEl={anchorRef?.current}
    open={isOpen}
    onClose={onClose}
    anchorOrigin={{
      vertical: 'top',
      horizontal: 'center',
    }}
    transformOrigin={{
      vertical: 'bottom',
      horizontal: 'center',
    }}
  >
    <Body>
      <Typography>
        To share products with customers, simply copy the product URL from your
        store and paste it into the chat
      </Typography>
      <Button size="small" onClick={onClose} variant="outlined">
        OK
      </Button>
    </Body>
  </StyledPopover>
);

export default ProductCatalogModal;
